<template>
    <div>
        <ModelSelect
            label="Центр компетенций"
            item-value="id"
            item-text="field_value"
            :items="dictionaryByType('centres_competition')"
            v-model="competenceCenter.centerCompetitionId"
            :disabled="false"
        />
        <div></div>
    </div>
</template>

<script>
import ModelSelect from '../../../UI/models/ModelSelect';
import ModelCheckbox from '../../../UI/models/ModelCheckbox';
import { mapActions, mapGetters } from 'vuex';

const getters = [
    'dictionaryByType',
];

const actions = [
    'loadDictionaryItems',
];

export default {
    name: 'WideCompetenceCenterData',
    props: {
        competenceCenter: Object,
    },
    model: {
        prop: 'competenceCenter',
    },
    components: {
        ModelSelect,
    },
    methods: {
        ...mapActions(actions),
    },
    computed: {
        ...mapGetters(getters),
    },
    mounted() {
        this.loadDictionaryItems('centres_competition');
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/account-data.scss';
</style>
